import { Record } from 'immutable';

import { RankingListEntity } from '../components/ranking-list/ranking-list.entity';

export interface IRankingState {
	loading: boolean;
	rankingList: RankingListEntity;
}

export const defaults: IRankingState = {
	loading: false,
	rankingList: RankingListEntity.build([]),
};

export const RankingFeatureKey = 'ranking';

export class RankingState extends Record<IRankingState>(defaults) {
	public static key = RankingFeatureKey;

	public setLoading(isLoading: boolean): RankingState {
		return this.set('loading', isLoading);
	}

	public setRankingList(rankingList: RankingListEntity): RankingState {
		return this.set('rankingList', rankingList);
	}
}
